import React from "react";

import { InfoSmIcon } from "@packages/ds";

import { IconControl } from "ds/Button";
import Dialog from "ds/Dialog";

type InfoProps = {
  title?: string;
  description?: string;
  link?: React.ReactNode;
};

const ChartInfo = (prop: InfoProps) => {
  return (
    <Dialog
      title={prop.title}
      description={prop.description}
      link={prop.link}
      trigger={
        <IconControl aria-label="chart-control">
          <InfoSmIcon />
        </IconControl>
      }
    />
  );
};

export default ChartInfo;
